'use strict';

import allRecommendations from './recommendations';

const dailyValues = allRecommendations['all-ages'];

const valueNutrients = [
    {
        title: 'Macros',
        nutrNos: [
            {nutrNo: '208'},                 // Calories
            {nutrNo: '204'},                 // Total Fat
            {nutrNo: '606'},                 // Saturated Fat (g)
            {nutrNo: '605'},                 // 605, indent, Trans Fat (g)
            {nutrNo: '646'},                 // 646, indent, Polyunsaturated Fat (g)
            {nutrNo: '645'},                 // Monounsaturated Fat (g)
            {nutrNo: '601'},                 // Cholesterol (mg)
            {nutrNo: '307'},                 // Sodium (mg)
            {nutrNo: '205'},                 // Carbohydrates (g)
            {nutrNo: '291'},                 // Fiber (g)
            {nutrNo: 'SFB'},                 // Soluable Fiber (g)
            {nutrNo: 'IFB'},                 // Insoluable Fiber (g)
            {nutrNo: '269'},                 // Sugar (g)
            {nutrNo: 'ASG'},                 // Sugar (Added)

            {nutrNo: '203'},                 // Protein (g)
            {nutrNo: 'FLU'},                 // Fluids (ml)
        ],
    },
    {
        title: 'Micro Nutrients',
        nutrNos: [
            {nutrNo: '324', dv: dailyValues['324']}, // Vitamin D - % x 400 IU (1 IU = 0.025 mcg)* (use 324)
            {nutrNo: '301', dv: dailyValues['301']}, // Calcium
            {nutrNo: '303', dv: dailyValues['303']}, // Iron - % x 18 mg
            {nutrNo: '306', dv: dailyValues['306']}, // Potassium (mg)

            {nutrNo: '318', dv: dailyValues['318']}, // Vitamin A - % x 5,000 IU (1 IU = 0.3 mg RAE) (use 318)
            {nutrNo: '415', dv: dailyValues['415']}, // Vitamin B6 - % x 2 mg
            {nutrNo: '418', dv: dailyValues['418']}, // Vitamin B12 - % x 6 ug
            {nutrNo: '401', dv: dailyValues['401']}, // Vitamin C - % x 60 mg
            {nutrNo: '323', dv: dailyValues['323']}, // Vitamin E - % x 30 IU (1 IU = 0.67 mg)
            {nutrNo: '430', dv: dailyValues['430']}, // Vitamin K
            {nutrNo: '404', dv: dailyValues['404']}, // Thiamin - % x 1.5 mg
            {nutrNo: '405', dv: dailyValues['405']}, // Riboflavin - % x 1.7 mg
            {nutrNo: '406', dv: dailyValues['406']}, // Niacin - % x 20 mg
            {nutrNo: '435', dv: dailyValues['435']}, // Folate (Folic Acid) - % x 400 ug
            {nutrNo: 'BIO', dv: dailyValues['BIO']}, // Biotin - % x 300 ug
            {nutrNo: '410', dv: dailyValues['410']}, // Pantothenic Acid - % x 10 mg
            {nutrNo: '305', dv: dailyValues['305']}, // Phosphorus - % x 1,000 mg
            {nutrNo: '304', dv: dailyValues['304']}, // Magnesium - % x 400 mg
            {nutrNo: '309', dv: dailyValues['309']}, // Zinc - % x 15 mg
            {nutrNo: '317', dv: dailyValues['317']}, // Selenium - % x 70 ug
            {nutrNo: '315', dv: dailyValues['315']}, // Manganese - % x 2 mg
            {nutrNo: 'MBD', dv: dailyValues['MBD']}, // Molybdenum - % x 75 ug

            {nutrNo: 'CHL', dv: dailyValues['CHL']}, // Chloride - % x 3,400 mg
            {nutrNo: '421', dv: dailyValues['421']}, // Choline, Total
            {nutrNo: '312', dv: dailyValues['312']}, // Copper - % x 2 mg (use 312)
            {nutrNo: 'IOD', dv: dailyValues['IOD']}, // Iodine - % x 150 ug
            {nutrNo: 'CHR'}, // Chromium, no daily recommended value
            {nutrNo: 'SUL'}, // Sulfites
        ],
    },
    {
        title: 'FODMAPs',
        fodmaps: true,
        nutrNos: [
            {nutrNo: 'OLF'}, // Oligos-fructans
            {nutrNo: 'OLG'}, // Oligos-GOS
            {nutrNo: 'FRC'}, // Fructose
            {nutrNo: 'LAC'}, // Lactose
            // {nutrNo: 'PLY'}, // Polyols
            {nutrNo: 'MAN'}, // Mannitol
            {nutrNo: 'SOR'}, // Sorbitol
        ],
    },
    {
        title: 'Fruits & Vegetable',
        nutrNos: [
            {nutrNo: 'FRU'}, // fruits
            {nutrNo: 'VEG'}, // non-starchy vegetables
            {nutrNo: 'SVG'}, // starchy vegetables
            {nutrNo: 'WHG'}, // whole grains
            {nutrNo: 'HLF'}, // healthy fats
            {nutrNo: 'LPR'}, // lean proteins
            {nutrNo: 'DAI'}, // dairy servings
            {nutrNo: 'LFY'}, // leafy greens
            {nutrNo: 'BER'}, // berries
            {nutrNo: 'NUT'}, // nuts/seeds
        ],
    },
    {
        title: 'Sugars & Alcohols',
        nutrNos: [
            {nutrNo: '221'},                 // Alcohol
            {nutrNo: 'SAL'},                 // Sugar Alcohol
            {nutrNo: '210'},                 // Sucrose
            {nutrNo: '211'},                 // Glucose
            {nutrNo: '214'},                 // Maltose
            {nutrNo: '213'},                 // Lactose (g)
            {nutrNo: '287'},                 // Galactose
        ],
    },
    {
        title: 'Derived Values',
        nutrNos: [
            {nutrNo: 'RAL', disabled: true}, // Potential Renal Acid Load
            {nutrNo: 'NTC', disabled: true}, // Net Carbs (g)
        ],
    },
    {
        title: 'Omega 3 & 6 Fatty Acids',
        nutrNos: [
            {nutrNo: '619'}, // Alpha-linolenic acid (undifferentiated)
            {nutrNo: '621'}, // Omega-3 (DHA)
            {nutrNo: '629'}, // Omega-3 (EPA)
            {nutrNo: '851'}, // Omega-3 (ALA)

            {nutrNo: '618'}, // Linoleic acid (undifferentiated)
            {nutrNo: '672'}, // Omega 6 (Eicosadienoic acid)
            {nutrNo: '675'}, // Omega 6 (Linoleic acid)
            {nutrNo: '685'}, // Omega 6 (Gamma-linoleic acid)
            {nutrNo: '853'}, // Omega 6 (Eicosatrienoic acid)
            {nutrNo: '855'}, // Omega 6 (Eicosatetraenoic acid)
        ],
    },
    {
        title: 'Other Fatty Acids',
        nutrNos: [
            {nutrNo: '607'}, // Butyric acid
            {nutrNo: '608'}, // Caproic acid
            {nutrNo: '609'}, // Caprylic acid
            {nutrNo: '610'}, // Capric acid
            {nutrNo: '611'}, // Lauric acid
            {nutrNo: '612'}, // Myristic acid
            {nutrNo: '613'}, // Palmitic acid
            {nutrNo: '614'}, // Stearic acid
            {nutrNo: '615'}, // Arachidic acid
            {nutrNo: '617'}, // Oleic acid (undifferentiated)
            {nutrNo: '620'}, // Arachidonic acid (undifferentiated)
            {nutrNo: '624'}, // Behenic acid
            {nutrNo: '625'}, // Myristoleic acid
            {nutrNo: '626'}, // Palmitoleic acid
            {nutrNo: '627'}, // Stearidonic acid
            {nutrNo: '628'}, // Eicosenoic acid
            {nutrNo: '630'}, // Erucic acid (undifferentiated)
            {nutrNo: '653'}, // Margaric acid
            {nutrNo: '654'}, // Lignoceric acid
            {nutrNo: '662'}, // Trans-palmitoleic acid
            {nutrNo: '670'}, // Conjugated Linoleic Acids
            {nutrNo: '671'}, // Nervonic acid
            {nutrNo: '673'}, // Palmitoleic acid
            {nutrNo: '674'}, // Oleic acid
            {nutrNo: '676'}, // Erucic acid
            {nutrNo: '687'}, // Heptadecenoic acid
            {nutrNo: '693'}, // Trans-monoenoic Fat
            {nutrNo: '695'}, // Trans-polyenoic Fat
            {nutrNo: '696'}, // Tridecanoic acid
            {nutrNo: '697'}, // Pentadecenoic acid
        ],
    },
    {
        title: 'Amino Acids',
        nutrNos: [
            {nutrNo: '454'}, // Betaine
            {nutrNo: '501'}, // Tryptophan
            {nutrNo: '502'}, // Threonine
            {nutrNo: '503'}, // Isoleucine
            {nutrNo: '504'}, // Leucine
            {nutrNo: '505'}, // Lysine
            {nutrNo: '506'}, // Methionine
            {nutrNo: '507'}, // Cystine
            {nutrNo: '508'}, // Phenylalanine
            {nutrNo: '509'}, // Tyrosine
            {nutrNo: '510'}, // Valine
            {nutrNo: '511'}, // Arginine
            {nutrNo: '512'}, // Histidine
            {nutrNo: '513'}, // Alanine
            {nutrNo: '514'}, // Aspartic acid
            {nutrNo: '515'}, // Glutamic acid
            {nutrNo: '516'}, // Glycine
            {nutrNo: '517'}, // Proline
            {nutrNo: '518'}, // Serine
            {nutrNo: '521'}, // Hydroxyproline
        ],
    },
];

export default valueNutrients;
